<template>
  <div class="PageMyReleaseOrder">
    <h2 class="includeBtn">{{ $t("pages.wording.myReleaseOrder") }}</h2>
    <!--我的放行單-->
    <div class="releaseOrderTopBox">
      <div class="releaseOrder releaseOrderTopText">
        {{ $t("pages.wording.releaseNo") }}: {{ ruleForm.releaseOrderNo }}
      </div>
      <!--releaseOrder-->
      <div class="releaseOrderTopText">
        {{ $t("pages.wording.reserve") }}:
        <a class="reserveOrderTitle" @click="applyReserveTempForm()">{{ titleReserveNo }}</a>
      </div>
      <!--reserveOrder-->
      <div class="Btn-Bottom-Content">
        <div class="Btn-Content">
          <el-button
            v-if="releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            class="button-right button-last"
            slot="reference"
            @click="cancelReleaseData()"
            type="danger"
            >{{ $t("pages.button.cencel") }}</el-button
          ><!--取消-->
          <el-button
            v-if="releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            class="button-right button-last"
            @click="applyReleaseData(false)"
            type="primary"
            >{{ $t("pages.button.save") }}</el-button
          ><!--儲存-->
          <el-button
            v-if="releaseData.isScale && releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            class="button-right"
            @click="applySoCredit()"
            type="warning"
            >{{ $t("pages.button.getSo") }}</el-button
          ><!--取得SO狀態-->
          <el-button
            v-if="releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            class="button-right"
            @click="applyReleaseData(true)"
            type="success"
            >{{ $t("pages.button.send") }}</el-button
          ><!--送出-->
          <el-button
            v-if="releaseData.releaseOrderStatus !== 'NEW' || readOnly"
            class="button-right"
            @click="applyClose()"
            type="success"
            >{{ $t("pages.button.close") }}</el-button
          ><!--關閉-->
          <el-button
            v-if="releaseData.releaseOrderStatus !== 'NEW'"
            class="button-right"
            @click="pdfDlownload()"
            type="success"
            >{{ $t("pages.button.pdfDownload") }}</el-button
          ><!--PDF Download-->
          <el-button
            v-if="releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            class="button-right"
            @click="goBack"
            type="info"
            >{{ $t("pages.button.back") }}</el-button
          >
        </div>
      </div>
      <!--Btn-Bottom-Content-->
    </div>
    <!--releaseOrderTopBox-->
    <el-collapse v-model="activeShowBlock">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input
                    disabled
                    v-model="ruleForm.applicatorName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input
                    disabled
                    v-model="ruleForm.deltaContactName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input
                    disabled
                    v-model="ruleForm.deltaContactNumber"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input
                    disabled
                    v-model="ruleForm.deltaContactMail"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="detail">
          <template slot="title">
            <h3>{{ $t("pages.wording.detailInfo") }}</h3>
            <!--詳細資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="OA Code" prop="oaCode"
                  ><!--OA Code-->
                  <el-input
                    disabled
                    v-model="ruleForm.oaCode"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input
                    disabled
                    v-model="ruleForm.vendor"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveDate"
                  ><!--預約抵達日期-->
                  <el-input
                    disabled
                    v-model="ruleForm.reserveArriveDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveTime')" prop="reserveArriveTime"
                  ><!--預約抵達時間-->
                  <el-input
                    disabled
                    v-model="ruleForm.reserveArriveTime"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carPlat"
                  ><!--車輛號牌-->
                  <el-input
                    disabled
                    v-model="ruleForm.carPlat"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.salesDate')" prop="saleDate"
                  ><!--出售日期-->
                  <el-input
                    disabled
                    v-model="ruleForm.reserveArriveDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input
                    disabled
                    v-model="ruleForm.reserveFactory"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input
                    disabled
                    :value="$store.getters.getSysCodeText('location', ruleForm.reserveLocation)"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.emptyCar')" prop="emptyCarWeight"
                  ><!--空車重量-->
                  <el-input
                    :disabled="releaseData.releaseOrderStatus != 'NEW' || readOnly"
                    type="number"
                    v-model="ruleForm.emptyCarWeight"
                    :rules="rules.emptyCarWeight"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.scaleLocation')" prop="scaleLocation"
                  ><!--過磅地點-->
                  <el-select
                    v-if="releaseData.releaseOrderStatus == 'NEW' && !readOnly"
                    v-model="ruleForm.scaleLocation"
                    :placeholder="$t('pages.wording.selectCarPlat')"
                    :rules="rules.scaleLocation"
                  >
                    <el-option
                      v-for="item in optionItem.scaleLocation"
                      :label="item[$i18n.locale]"
                      :value="item.code"
                      :key="item.code"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-else
                    disabled
                    :value="$store.getters.getSysCodeText('scaleLocation', ruleForm.scaleLocation)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
      <el-form ref="soRuleForm" :model="soRuleForm" :rules="rules" label-width="0px">
        <el-collapse-item class="collapsecontent" name="materialDetial">
          <template slot="title">
            <h3>{{ $t("pages.wording.materialDetial") }}</h3>
            <!--廢料明細資訊-->
          </template>
          <div class="boxContain c-table includeBtn">
            <div
              class="c-table-top-right-btn"
              v-if="releaseData.isScale && releaseData.releaseOrderStatus === 'NEW' && !readOnly"
            >
              <el-button icon="el-icon-plus" @click="updateSoToERP()" type="warning">{{
                $t("pages.button.updateSO")
              }}</el-button
              ><!--更新SO-->
            </div>
            <el-tabs v-model="activeName">
              <el-tab-pane label="preProcess" name="first">
                <span slot="label"><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.materialInfo") }}</span
                ><!--廢料明細-->
                <div class="s-table">
                  <template>
                    <el-table :data="soRuleForm.soList" class="soList" border style="width: 100%" height="450px">
                      <el-table-column prop="SO" label="SO" width="110"></el-table-column
                      ><!--SO--><!--so-->
                      <el-table-column prop="SOLine" label="SO LINE" width="80"></el-table-column
                      ><!--SO LINE--><!--soLine-->
                      <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="150"></el-table-column
                      ><!--廢料料號--><!--partNo-->
                      <el-table-column :label="$t('pages.wording.partName')" width="160">
                        <template slot-scope="scope">
                          {{ displayPartName(getLanguage(), scope.row.partNameCN, scope.row.partName) }}
                        </template>
                      </el-table-column>
                      <!--廢料名稱--><!--partName-->
                      <el-table-column :label="$t('pages.wording.grossWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.grossWeight'" :rules="rules.grossWeight">
                            <el-input
                              :disabled="releaseData.releaseOrderStatus != 'NEW' || readOnly"
                              v-model="scope.row.grossWeight"
                              type="number"
                              @change="setWeight(scope.$index, scope.row, 'gross')"
                            />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--毛重--><!--grossWeight-->
                      <el-table-column :label="$t('pages.wording.packType')" width="220">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packType'" :rules="rules.packType">
                            <el-select
                              v-if="releaseData.releaseOrderStatus == 'NEW' && !readOnly"
                              v-model="scope.row.packType"
                            >
                              <el-option
                                v-for="item in optionItem.packType"
                                :label="item[$i18n.locale]"
                                :value="item.code"
                                :key="item.code"
                              ></el-option
                              ><!--手推車-->
                            </el-select>
                            <el-input
                              v-else
                              disabled
                              :value="$store.getters.getSysCodeText('packType', scope.row.packType)"
                            ></el-input>
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝種類--><!--packType-->
                      <el-table-column :label="$t('pages.wording.packNumber')" width="140">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packNumber'" :rules="rules.packNumber">
                            <el-input
                              :disabled="releaseData.releaseOrderStatus != 'NEW' || readOnly"
                              type="number"
                              @keyup.native="
                                checkIsDigitalAndNumOfDecimal(scope.$index, scope.row.packNumber, 'packNumber')
                              "
                              :step="0.0001"
                              v-model="scope.row.packNumber"
                            />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝數量--><!--packNumber-->
                      <el-table-column :label="$t('pages.wording.packWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packWeight'" :rules="rules.packWeight">
                            <el-input
                              :disabled="releaseData.releaseOrderStatus != 'NEW' || readOnly"
                              type="number"
                              @keyup.native="
                                checkIsDigitalAndNumOfDecimal(scope.$index, scope.row.packWeight, 'packWeight')
                              "
                              :step="0.0001"
                              v-model="scope.row.packWeight"
                              @change="setWeight(scope.$index, scope.row, 'pack')"
                            />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--總皮重--><!--packWeight-->
                      <el-table-column
                        prop="netWeight"
                        :label="$t('pages.wording.netWeight')"
                        width="120"
                        @change="setWeight(scope.$index, scope.row, 'net')"
                      >
                      </el-table-column
                      ><!--淨重--><!--netWeight-->
                      <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="120"></el-table-column
                      ><!--單位--><!--unit-->
                      <el-table-column prop="plantCode" label="Plant Code" width="120"></el-table-column
                      ><!--PlantCode--><!--plantCode-->
                      <el-table-column prop="storageLogic" label="Storage Loc." width="120"></el-table-column
                      ><!--PlantCode--><!--storageLogic-->
                    </el-table>
                  </template>
                </div>
                <!--s-table--> </el-tab-pane
              ><!--preProcess-->
            </el-tabs>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
      <el-collapse-item class="collapsecontent" name="signDetail">
        <template slot="title">
          <h3>{{ $t("pages.wording.signProcess") }}</h3>
          <!--詳細資訊-->
        </template>
        <el-table class="dialogSoCredit" :data="signTable" border style="width: 100%" height="300px">
          <el-table-column prop="signRole" :label="$t('pages.wording.role')" width="">
            <template slot-scope="scope">
              {{ $t("role." + scope.row.signRole) }}
            </template> </el-table-column
          ><!--角色-->
          <el-table-column prop="signUserName" :label="$t('pages.wording.signUserName')" width=""> </el-table-column
          ><!--簽核者-->
          <el-table-column prop="signUserID" :label="$t('pages.wording.signUserID')" width="200"> </el-table-column
          ><!--工號-->
          <el-table-column prop="date" :label="$t('pages.wording.ExamDate')" width="">
            <template slot-scope="scope">
              {{ scope.row.signDate }} {{ scope.row.signTime }}
            </template> </el-table-column
          ><!--簽核日期時間-->
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <el-dialog :title="$t('pages.wording.soStatus')" :visible.sync="dialog.soCredit.showDialog" width="50%">
      <el-table
        class="dialogSoCredit"
        :data="soRuleForm.soList"
        border
        style="width: 90%"
        height="300px"
        :default-sort="{ prop: 'so', order: 'descending' }"
      >
        <el-table-column prop="SO" label="SO" width=""> </el-table-column
        ><!--SO-->
        <el-table-column prop="SOLine" label="SO ITEM" width="100"> </el-table-column
        ><!--SOLINE-->
        <el-table-column prop="creditStatus" :label="$t('pages.wording.creditStatus')" width="120"> </el-table-column
        ><!--單據信用狀態-->
      </el-table>
      <div id="creditText">{{ $t("pages.wording.creditStatus") }}: P(Open)、R(Release)</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.soCredit.showDialog = false">{{
          $t("pages.button.confirm")
        }}</el-button
        ><!--確定-->
      </span>
    </el-dialog>
    <PDFDownload :ref="releaseData.releaseOrderNo" :releaseID="id"></PDFDownload>
  </div>
  <!--PageMyReleaseOrder-->
</template>

<script>
import { store } from "@/store/store.js"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import PDFDownload from "@/components/PDFDownload.vue"
import { role } from "@/config/role.js"
import { mapGetters } from "vuex"
export default {
  name: "PageMyReleaseOrderForm",
  props: ["id", "prvPageInfo"],
  components: {
    PDFDownload,
  },
  data() {
    return {
      readOnly: false,
      activeName: "first",
      submitData: {},
      releaseData: {},
      reserveData: {},
      titleReserveNo: "",
      soList: [],
      signTable: [],
      roleNotYetSign: false,
      showBackPrvButton: false,
      applicator: {
        name: "",
        number: "",
        deptName: "",
        area: "",
        deptCode: "",
      },
      dialog: {
        soCredit: {
          showDialog: false,
        },
      },
      optionItem: {
        scaleLocation: [],
        packType: [],
      },
      ruleForm: {
        //基本資訊
        releaseOrderNo: "",
        reserveNo: "",
        applicatorName: "", //申請人
        applicatorNT: "",
        deltaContactName: "", //台達接洽人
        deltaContactNumber: "", //台達接洽人電話
        deltaContactMail: "", //台達接洽人Mail
        //詳細資訊
        oaCode: "",
        vendor: "", //廠商名稱
        reserveArriveDate: "", //進廠日期
        reserveArriveTime: "", //進廠時間
        carPlat: "", //車牌
        saleDate: "", //出售日期
        reserveFactory: "", //抵達廠別
        reserveLocation: "", //抵達地點
        emptyCarWeight: "", //空車重量
        scaleLocation: "", //過磅地點
        //others
        soCreditStatus: false,
        //撈下拉清單用
        reserveRegion: "",
        reserveArea: "",
      },
      soRuleForm: {
        soList: [],
      },
      rules: {
        emptyCarWeight: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        grossWeight: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        packType: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        scaleLocation: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        packNumber: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
      },
      activeShowBlock: ["basic", "detail", "materialDetial", "signDetail"],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles", "getLanguage"]),
    init() {
      let vueInstance = this
      if (vueInstance.prvPageInfo !== undefined && vueInstance.prvPageInfo !== null) {
        vueInstance.showBackPrvButton = true
      }
      let userRoles = vueInstance.getUserRoles() ?? []
      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        vueInstance.readOnly = true
      }
      let releaseID = vueInstance.$props.id === undefined ? vueInstance.$route.query.id : vueInstance.$props.id
      vueInstance.getReleaseInfo(releaseID)
      vueInstance.getSignTable(releaseID)
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    getReleaseInfo(id) {
      let paramter = { releaseId: id }
      this.$store.dispatch("getReleaseInfo", { params: paramter })
    },
    getSignTable(id) {
      let vueInstance = this
      let params = { releaseId: id }
      api
        .apiGetSignTable(params)
        .then((response) => {
          if (response.data.success) {
            vueInstance.signTable = response.data.result
          }
        })
        .catch(function (e) {
          console.log(e)
        })
    },
    buildReleaseInfo(data) {
      this.ruleForm.saleDate = data.saleDate
      this.ruleForm.emptyCarWeight = data.emptyCarWeight
      this.ruleForm.scaleLocation = data.scaleLocation
      this.ruleForm.releaseOrderNo = data.releaseOrderNo
    },
    buildReserveInfo(data) {
      this.ruleForm.reserveNo = data.reserveNo
      this.titleReserveNo =
        this.ruleForm.reserveNo === utils.getDefaultReserveNo()
          ? this.$t("pages.wording.reserveNoIsDefault")
          : this.ruleForm.reserveNo
      this.ruleForm.applicatorName = data.applicatorName
      this.ruleForm.applicatorNT = data.applicatorNT
      this.ruleForm.deltaContactName = data.deltaContactName
      this.ruleForm.deltaContactNumber = data.deltaContactNumber
      this.ruleForm.deltaContactMail = data.deltaContactMail
      this.ruleForm.oaCode = data.OACode
      this.ruleForm.vendor = data.vendor
      this.ruleForm.reserveArriveDate = utils.getFormateDateTime("Date", data.reserveArriveDatetime)
      this.ruleForm.reserveArriveTime = utils.getFormateDateTime("Time", data.reserveArriveDatetime)
      if (data.tempCar) this.ruleForm.carPlat = data.tmpCarPlat
      else this.ruleForm.carPlat = data.carPlat
      this.ruleForm.reserveFactory = data.reserveFactory
      this.ruleForm.reserveLocation = data.reserveLocation
      this.ruleForm.reserveRegion = data.reserveRegion
      this.ruleForm.reserveArea = data.reserveArea
    },
    buildSoListInfo(datas) {
      this.soRuleForm.soList = datas
    },
    setWeight(index, row, changecolName) {
      let isScale = row.isScale
      if (isScale && changecolName === "net") {
        return
      }
      if (!isScale && changecolName === "gross") {
        return
      }
      if (isScale) {
        let grossWeight = row.grossWeight
        let packWeight = row.packWeight

        let netWeight = grossWeight - packWeight
        netWeight = parseFloat(netWeight).toFixed(this.$global.defaultPointNumForRelease)
        this.soRuleForm.soList[index].netWeight = netWeight > 0 ? netWeight : 0

        if (netWeight < 0)
          utils.alertMessage(
            this,
            1,
            this.$t("message.alert.notGreaterThan", {
              0: this.$t("pages.wording.packWeight"),
              1: this.$t("pages.wording.grossWeight"),
            })
          )
      } else {
        let grossWeight = parseFloat(row.packWeight) + parseFloat(row.netWeight)
        grossWeight = parseFloat(grossWeight).toFixed(this.$global.defaultPointNumForRelease)
        this.soRuleForm.soList[index].grossWeight = grossWeight
      }
    },
    checkNetWeight() {
      let errorItems = this.soRuleForm.soList.find(function (item, index) {
        let grossWeight = item.grossWeight
        let packWeight = item.packWeight

        let netWeight = grossWeight - packWeight
        return netWeight < 0
      })
      if (errorItems != undefined) return false
      return true
    },
    checkIsDigitalAndNumOfDecimal(index, val, colName) {
      this.soRuleForm.soList[index][colName] = utils.matchIsDigitalAndNumOfDecimal(
        val,
        this.$global.defaultPointNumForRelease
      )[0]
    },
    async applySoCredit() {
      await this.updateSoCredit()
      this.dialog.soCredit.showDialog = true
    },
    applyClose() {
      this.goBack()
    },
    updateSoCredit() {
      //同步處理
      let soList = []
      this.soList.forEach(function (item, index) {
        let soInfo = {}
        soInfo.SO = item.SO

        soList.push(soInfo)
      })
      let getSoCreditPara = {
        I_WERKS: this.soList[0].plantCode,
        I_VAM_NO: this.reserveData.reserveNo,
        IT_SO: {
          item: soList,
        },
      }

      let vm = this

      return new Promise((resolve) => {
        api
          .apiGetSOCredit(getSoCreditPara)
          .then((response) => {
            if (response.data.code == 0) {
              const soResult = response.data.result

              let soReturn = soResult.item

              this.soRuleForm.soList.forEach(function (item, index) {
                let so = item.SO
                let soItem = item.SOLine

                let soCredit = soReturn.find(function (item, index) {
                  return item.SO == so && item.SO_ITEM == soItem
                })
                if (soCredit != undefined) vm.soRuleForm.soList[index].creditStatus = soCredit.CREDIT_STATUS
              })
              resolve(vm.checkSoCredit())
            } else {
              utils.alertMessage(vm, 1, this.$t("message.alert.failGetSoStatus"))
            }
          })
          .catch(function (e) {
            utils.alertMessage(vm, 1, this.$t("message.alert.failGetSoStatus"))
          })
      })
    },
    applyReserveTempForm() {
      let routeData = this.$router.resolve({
        name: "PageMyReservationTempForm",
        query: { id: this.reserveData.id },
      })
      window.open(routeData.href, "_blank")
    },
    checkSoCredit() {
      let soCreditStatus = this.soRuleForm.soList.filter(function (item, index) {
        return item.creditStatus == "P"
      })
      if (soCreditStatus.length <= 0) {
        this.ruleForm.soCreditStatus = true
      }
      return this.ruleForm.soCreditStatus
    },
    async buildApplySubmit(status) {
      let vm = this

      //基本資料Update
      vm.submitData.releaseData.emptyCarWeight = parseInt(vm.ruleForm.emptyCarWeight)
      vm.submitData.releaseData.scaleLocation = vm.ruleForm.scaleLocation
      vm.submitData.releaseData.soCreditStatus = vm.ruleForm.soCreditStatus

      //SO update
      vm.submitData.soList.forEach(function (item, index) {
        var so = item.SO
        var partNo = item.partNo

        var ruleFormSoData = vm.soRuleForm.soList.find(function (element, index) {
          return element.SO == so && element.partNo == partNo
        })
        vm.submitData.soList[index].grossWeight = parseFloat(ruleFormSoData.grossWeight)
        vm.submitData.soList[index].packType = ruleFormSoData.packType
        vm.submitData.soList[index].packNumber = parseFloat(ruleFormSoData.packNumber)
        vm.submitData.soList[index].packWeight = parseFloat(ruleFormSoData.packWeight)
        vm.submitData.soList[index].netWeight = parseFloat(ruleFormSoData.netWeight)
      })
      //Status update
      vm.submitData.releaseData.releaseOrderStatus = status
      //放行SO單更新
      let updateParams = {
        releaseData: vm.submitData.releaseData,
        logOperator: store.state.UserLoginData.userName,
      }
      let soParams = {
        soList: vm.submitData.soList,
        logOperator: store.state.UserLoginData.userName,
      }
      let releaseANSoParams = {
        updateParams: updateParams,
        soParams: soParams,
      }

      let today = utils.getDateTime(new Date())

      let signItem = {
        id: 0,
        signRole: vm.getUserRoles(),
        signUserID: store.state.UserLoginData.userEmpID,
        signDate: today[0],
        signTime: today[1],
        signDatetime: utils.getISOString("now"),
        releaseOrderRef: vm.releaseData.id,
        signResult: true,
        signUserName: store.state.UserLoginData.userName,
        signUserNT: store.state.UserLoginData.userAD,
      }

      let signInfo = {
        resignReason: "",
        logOperator: store.state.UserLoginData.userName,
        signItem: signItem,
      }

      let signList = []
      signList.push(signInfo)

      let releaseANSoANSignParams = {
        updateParams: updateParams,
        signListParams: signList,
      }

      let buildDatas = {
        releaseANSoANSignParams: releaseANSoANSignParams,
        releaseANSoParams: releaseANSoParams,
      }

      return buildDatas
    },
    cancelReleaseData() {
      let vueInstance = this
      vueInstance
        .$confirm(vueInstance.$t("pages.button.confirmcancelrelease"))
        .then((_) => {
          utils.showLoading(vueInstance)
          let params = {
            reserveID: vueInstance.reserveData.id,
            releaseID: vueInstance.releaseData.id,
          }
          api
            .apiCancelReleaseData(params)
            .then((response) => {
              utils.closeLoading(vueInstance)
              if (response.data.success) {
                vueInstance.$message({
                  message: vueInstance.$t("message.alert.successCancel"),
                  type: "success",
                })
                vueInstance.$router.push({
                  name: "PageMyReleaseOrder",
                })
              } else {
                utils.alertMessage(vueInstance, 1, response.data.messageCode)
              }
            })
            .catch(function (e) {
              utils.closeLoading(vueInstance)
              utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.failCancel"))
            })
        })
        .catch((_) => {})
    },
    async applyReleaseData(submitToSign) {
      let vueInstance = this
      if (submitToSign) {
        //需地磅預約單
        if (vueInstance.releaseData.isScale) {
          let releaseCredit = await vueInstance.updateSoCredit() //同步處理SoCredit
          if (!releaseCredit) {
            //檢查release
            utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.soStatusNoRelease"))
            return false
          }
        }
        //確定皮重不得大於毛重
        let checkNetWeight = vueInstance.checkNetWeight()
        if (!checkNetWeight) {
          utils.alertMessage(
            vueInstance,
            1,
            this.$t("message.alert.notGreaterThan", {
              0: this.$t("pages.wording.packWeight"),
              1: this.$t("pages.wording.grossWeight"),
            })
          )
          return false
        }
      }

      let isValid = true
      //檢查SO必填欄位
      this.$refs["soRuleForm"].validate((valid) => {
        if (!valid) {
          isValid = false
        }
      })
      //檢查基本資訊必填欄位
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) {
          isValid = false
        }
      })

      if (!isValid && submitToSign) {
        //未填alert
        utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.checkRequiredField"))
        return false
      }
      utils.showLoading(vueInstance)

      //基本資料Update
      vueInstance.submitData.releaseData.emptyCarWeight = parseInt(vueInstance.ruleForm.emptyCarWeight)
      vueInstance.submitData.releaseData.scaleLocation = vueInstance.ruleForm.scaleLocation
      vueInstance.submitData.releaseData.soCreditStatus = vueInstance.ruleForm.soCreditStatus

      //SO update
      vueInstance.submitData.soList.forEach(function (item, index) {
        let so = item.SO
        let partNo = item.partNo

        let ruleFormSoData = vueInstance.soRuleForm.soList.find(function (element, index) {
          return element.SO == so && element.partNo == partNo
        })
        vueInstance.submitData.soList[index].grossWeight = parseFloat(ruleFormSoData.grossWeight)
        vueInstance.submitData.soList[index].packType = ruleFormSoData.packType
        vueInstance.submitData.soList[index].packNumber = parseFloat(ruleFormSoData.packNumber)
        vueInstance.submitData.soList[index].packWeight = parseFloat(ruleFormSoData.packWeight)
        vueInstance.submitData.soList[index].netWeight = parseFloat(ruleFormSoData.netWeight)
      })

      let params = {
        reserveID: vueInstance.reserveData.id,
        releaseID: vueInstance.releaseData.id,
        releaseData: vueInstance.submitData.releaseData,
        SOList: vueInstance.submitData.soList,
        submitToSign: submitToSign,
      }
      api
        .apiSaveOrSubmitReleaseData(params)
        .then((response) => {
          utils.closeLoading(vueInstance)
          if (response.data.success) {
            vueInstance.$alert(
              submitToSign
                ? vueInstance.$t("message.alert.successSubmit")
                : vueInstance.$t("message.alert.successSave"),
              vueInstance.$t("message.title.success"),
              {
                confirmButtonText: vueInstance.$t("pages.button.confirm"),
                callback: () => {
                  vueInstance.$router.push({
                    name: "PageMyReleaseOrder",
                  })
                },
              }
            )
          } else {
            utils.alertMessage(vueInstance, 1, response.data.messageCode)
          }
        })
        .catch(function (e) {
          utils.closeLoading(vueInstance)
          utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.submitFail"))
        })
    },
    pdfDlownload() {
      this.$refs[this.releaseData.releaseOrderNo].pdfDlownload()
    },
    async updateSoToERP() {
      let it_orders = []
      let planCode = ""
      let vm = this

      let isValid = true
      this.$refs["soRuleForm"].validate((valid) => {
        //檢查SO必填欄位
        if (!valid) isValid = false
      })

      if (!isValid) {
        //未填alert
        utils.alertMessage(vm, 1, vm.$t("message.alert.checkRequiredField"))
        console.log("error submit!!")
        return false
      }

      this.soRuleForm.soList.forEach(function (item, index) {
        if (index == 0) planCode = item.plantCode

        let items = {
          SO: item.SO,
          SO_ITEM: item.SOLine,
          MATNR: item.partNo, //Material number
          KWMENG: parseFloat(item.netWeight), //數量
          MEINS: item.unit, //Unit of measure
        }
        it_orders.push(items)
      })

      let parameter = {
        I_VAM_NO: this.reserveData.reserveNo,
        I_WERKS: planCode,
        IT_ORDER: {
          item: it_orders,
        },
      }
      this.$store.dispatch("updateSoToERP", parameter)

      let cb = function () {}

      let data
      await this.buildApplySubmit("NEW").then((response) => {
        data = response
      })
      this.$store.dispatch("updateReleaseANSo", {
        params: data.releaseANSoParams,
        cb: cb,
      })
    },
    goBack() {
      if (
        this.$route.params.prevPageParams !== undefined &&
        this.$route.params.prevPageParams.routeName !== undefined
      ) {
        switch (this.$route.params.prevPageParams.routeName) {
          case "PageMyReleaseOrder":
          case "PageSearchReleaseOrder":
            this.setQueryParamsToStorage()
            break
          case "PageMyReservationTempForm":
          case "PageMyReservationInfo":
            break
        }
      }
      this.$router.push({
        name:
          this.$route.params.prevPageParams === undefined
            ? this.$route.query.routeName
            : this.$route.params.prevPageParams.routeName,
        params:
          this.$route.params.prevPageParams === undefined
            ? this.$route.query.routeName
            : this.$route.params.prevPageParams.routeName,
      })
    },
    setQueryParamsToStorage() {
      window.sessionStorage.setItem("queryParams", JSON.stringify(this.$route.params.queryParams))
    },
    async getScaleLocation() {
      this.optionItem.scaleLocation = await utils.getCodeListWithCulture(
        this.ruleForm.reserveRegion,
        this.ruleForm.reserveArea,
        "scaleLocation"
      )
    },
    async getPackType() {
      this.optionItem.packType = await utils.getCodeListWithCulture(
        this.ruleForm.reserveRegion,
        this.ruleForm.reserveArea,
        "packType"
      )
    },
    formateDatetimeStr(type, dtstring) {
      utils(type, dtstring)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      let code = val.code
      let message = val.message
      let cb = val.cb
      let title = code == 0 ? "success" : "fail"

      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.releaseInfo": function (val) {
      //資料by Rlease No 抓取並回傳且build到頁面上
      //save as submit structure
      this.submitData = {
        releaseData: val.releseData,
        soList: val.soList,
      }
      //save as origion data
      this.releaseData = val.releseData
      this.reserveData = val.reserveData
      this.soList = val.soList

      //build page data
      this.buildReleaseInfo(this.releaseData)
      this.buildReserveInfo(this.reserveData)
      this.buildSoListInfo(this.soList)
      this.getScaleLocation()
      this.getPackType()
    },
  },
}
</script>

<style>
.releaseOrderTopBox {
  position: relative;
  margin-bottom: 15px;
}
.releaseOrderTopBox .releaseOrderTopText {
  display: inline-block;
  font-size: 1.8rem;
  width: 50%;
}

.soList .el-form-item__content input {
  width: 100%;
  height: 30px;
}
.soList .el-form-item {
  margin-bottom: 0px;
}
.reserveOrderTitle {
  color: #007bff !important;
  cursor: pointer;
}
.reserveOrderTitle:hover {
  text-decoration: underline !important;
}
#app .dialogSoCredit {
  margin: 0px auto;
  border: 1px #ccc solid;
}
#app .dialogSoCredit th {
  background-color: #f5f5f5;
  font-weight: bolder;
}
#creditText {
  width: 90%;
  margin: 10px auto;
}
.soList table .is-error .el-input {
  margin-bottom: 12px;
}
.soList table .is-error .el-form-item__error {
  top: 70%;
}
#PDFDownloadContainer {
  height: 1px;
  position: absolute;
  overflow: hidden;
}
#PDFDownload {
  position: absolute;
  width: 1240px;
  height: 1754px;
  font-size: 18px;
}
#PDFDownloadContent {
  margin: 50px;
}
#pdf-title {
  width: 100%;
  text-align: center;
  margin: 10px auto;
  border-bottom: 1px #000 solid;
}
#PDFDownload .el-row {
  margin: 10px 0px;
}
#PDFDownload .pdf-box {
  padding-bottom: 30px;
  border-bottom: 1px #000 solid;
}
</style>
<style scoped>
.Btn-Bottom-Content {
  position: fixed !important;
  background: rgb(22, 22, 21) !important;
  background: linear-gradient(
    0deg,
    rgba(22, 22, 21, 0.7931547619047619) 26%,
    rgba(255, 255, 255, 0.03125) 96%
  ) !important;
  z-index: 5 !important;
  height: 100px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  overflow: hidden !important;
}
.Btn-Content {
  width: 93%;
}
.button-right {
  margin-left: 10px !important;
  margin-top: 5px !important;
}
.button-last {
  margin-left: 10px !important;
}

@media (max-width: 768px) {
  .releaseOrderTopBox .releaseOrderTopText {
    width: 100%;
  }
}

@media (max-width: 1025px) {
  .Btn-Bottom-Content {
    left: 0px !important;
  }
}
@media (min-width: 1026px) {
  .menuOpen .Btn-Bottom-Content {
    left: 299px !important;
  }
}
</style>
